import React from 'react';
export default function Rule() {
	return <hr role="presentation" />;
}
